<template>

    <div >
        <el-form :inline="true" :model="searchForm"  >
            <el-form-item label="所属代理商：">
                <el-select v-model="searchForm.agentId" filterable placeholder="请选择或输入关键字" clearable>
                    <el-option v-for="item in agentsOption" :value="item.agentId" :key="item.agentId" :label="item.agentName"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>

            <el-form-item class="btnArea">
                <el-button type="primary"  @click="getSmsStatisticsHandler()">查 询</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border height="611" style="width: 100%">
            <el-table-column type="index" label="序号" width="80px"></el-table-column>
            <el-table-column prop="agentName" label="代理商名称"></el-table-column>
            <el-table-column prop="sendSuccess" label="发送成功" ></el-table-column>
            <el-table-column prop="sendFail" label="发送失败" ></el-table-column>
            <el-table-column prop="acceptSuccess" label="接收成功" ></el-table-column>
            <el-table-column prop="acceptFail" label="接受失败" ></el-table-column>
        </el-table>  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>

    </div>
</template>

<script>
import {getSmsStatistics, } from '@/api/sms.js'
import common from '@/utils/common.js'
export default {
    data(){   
        return {
            searchForm: {
                agentId: null,
                time: null,
            },
            agentsOption: [],
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
        }
    },

    methods: {
        getSmsStatisticsHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);            
            getSmsStatistics(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },


        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getSmsStatisticsHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getSmsStatisticsHandler();
        }       
    },

    created () {
        this.getSmsStatisticsHandler();
        common.sysRequest('/agent/listOption', {}, 'post').then(res => {
            if(res.data.code == 200){
                this.agentsOption = res.data.data;
            }

        }); 
    }
}
</script>